import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_VAT_RATE_LIST: string = typeCreatorV2(
  'VatRateReducer',
  'SetVatRateList'
);

export const SET_UPDATE_VAT_RATE: string = typeCreatorV2(
  'VatRateReducer',
  'SetUpdateVatRate'
);

export const SET_VAT_RATE_TYPES: string = typeCreatorV2(
  'VatRateReducer',
  'SetVatRateTypes'
);

export const SET_ADD_VAT_RATE: string = typeCreatorV2(
  'VatRateReducer',
  'SetAddVatRate'
);
